import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../utils/api";
import "./AdminForm.css";

export default function AdminAddProduct() {
  const [title, setTitle] = useState("");
  const [price, setPrice] = useState("");
  const [image, setImage] = useState(null);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const previewUrl = useMemo(() => {
    if (!image) return null;
    return URL.createObjectURL(image);
  }, [image]);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);

    try {
      const fd = new FormData();
      fd.append("title", title);
      fd.append("price_aed", price);
      if (image) fd.append("image", image);

      await api.post("/api/products", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      navigate("/admin/products");
    } catch (error) {
      setErr(error.response?.data?.message || "Failed to add product");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="adminAddWrap">
      <div className="adminAddCard">
        {/* Header */}
        <div className="adminAddTop">
          <div>
            <h2 className="adminAddTitle">Add Product</h2>
            <p className="adminAddSub">Create a new product for your shop.</p>
          </div>

          <button
            type="button"
            className="btnSecondary"
            onClick={() => navigate("/admin/dashboard")}
          >
            ← Dashboard
          </button>
        </div>

        {err && <div className="formError">{err}</div>}

        {/* Body */}
        <div className="adminAddBody">
          {/* Left preview panel */}
          <div className="previewPanel">
            <div className="previewBox">
              {previewUrl ? (
                <img src={previewUrl} alt="preview" />
              ) : (
                <div className="previewPlaceholder">
                  <div className="previewIcon">🖼️</div>
                  <h4>Product Preview</h4>
                  <p>Upload an image to see preview here.</p>
                </div>
              )}
            </div>

            <label className="uploadBtn">
              Upload Image
              <input
                type="file"
                accept="image/*"
                onChange={(e) => setImage(e.target.files?.[0] || null)}
                hidden
              />
            </label>

            <div className="hintText">
              Recommended: 1200×1200 (square) • PNG/JPG/WebP
            </div>
          </div>

          {/* Right form */}
          <form className="adminFormPro" onSubmit={submit}>
            <div className="field">
              <label>Title</label>
              <input
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="e.g. Calm Quote Tote"
                required
              />
            </div>

            <div className="field">
              <label>Price (AED)</label>
              <input
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                placeholder="e.g. 49"
                inputMode="decimal"
                required
              />
            </div>

            <div className="actionRow">
              <button
                type="button"
                className="btnGhost"
                onClick={() => navigate("/admin/products")}
              >
                View Products
              </button>

              <button className="btnPrimary" disabled={loading}>
                {loading ? "Saving..." : "Save Product"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}